import React, { useState } from 'react';
import { Fab, Tooltip, Box } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { CLINIC_INFO } from '../../data/siteData';

export default function WhatsAppButton() {
  const [pulse, setPulse] = useState(true);

  const handleClick = () => {
    setPulse(false);
    const msg = encodeURIComponent("Hello, I would like to book an appointment at Noble Dental Surgery.");
    window.open(`https://wa.me/${CLINIC_INFO.whatsapp}?text=${msg}`, '_blank');
  };

  return (
    <Tooltip title="Chat on WhatsApp" placement="left" arrow>
      <Box
        sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1000 }}
        onClick={handleClick}
      >
        {pulse && (
          <Box sx={{
            position: 'absolute', inset: 0,
            borderRadius: '50%',
            bgcolor: '#25D366',
            opacity: 0.4,
            animation: 'waPulse 2s infinite',
            '@keyframes waPulse': {
              '0%': { transform: 'scale(1)', opacity: 0.4 },
              '70%': { transform: 'scale(1.8)', opacity: 0 },
              '100%': { transform: 'scale(1.8)', opacity: 0 },
            }
          }} />
        )}
        <Fab
          aria-label="Chat on WhatsApp"
          sx={{
            bgcolor: '#25D366',
            color: '#fff',
            boxShadow: '0 4px 20px rgba(37,211,102,0.5)',
            '&:hover': {
              bgcolor: '#20BD5C',
              transform: 'scale(1.1)',
              boxShadow: '0 6px 24px rgba(37,211,102,0.6)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 28 }} />
        </Fab>
      </Box>
    </Tooltip>
  );
}
